import { Component, OnInit, inject } from '@angular/core';

import { UserService } from '@frontend/vanilla/core';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    selector: 'vn-am-last-login',
    templateUrl: 'last-login.html',
})
export class LastLoginComponent extends AccountMenuItemBase implements OnInit {
    private user = inject(UserService);

    message: string;
    show: boolean = true;

    ngOnInit() {
        if (this.user.isFirstLogin) {
            this.show = false;
        } else {
            this.message = this.item.text.replace('__DATE__', this.user.lastLoginTimeFormatted!);
        }
    }
}
